import styles from './styles.module.scss'
import { withModifiers } from '../../helpers/withModifiers'
import LazyImage from '../../elements/LazyImage'
import Button from '../../elements/Button'
import { getS3Url } from '../../helpers/getS3Url'

const Staff = ({
  picture,
  cloudflare_picture,
  email,
  variant = [],
  width,
  height,
  first_name,
  last_name,
  job,
  subtitle,
  button = true
}) => {
  const isGeneral = variant.includes('general')
  const removeJob = variant.includes('remove-job')

  return (
    <div className={withModifiers('staff', variant, styles)}>
      <div
        className={styles.staff__image}
        style={{
          width: width || 180,
          height: height || 260
        }}
      >
        {picture && (
          <LazyImage
            alt={`Profile image-${picture}`}
            layout="fill"
            key={picture}
            src={
              cloudflare_picture
                ? getS3Url(cloudflare_picture, '640')
                : getS3Url(picture)
            }
          />
        )}
      </div>

      <div className={styles.staff__details}>
        {(first_name || last_name) && (
          <div className={styles.staff__name}>
            {first_name} {last_name}
          </div>
        )}

        {job && !removeJob && (
          <div
            className={withModifiers(
              'staff__position',
              [isGeneral && 'general'],
              styles
            )}
          >
            {job}
          </div>
        )}

        {subtitle && <div className={styles.staff__subtitle}>{subtitle}</div>}

        {button && (
          <Button
            rel="nofollow"
            href={`mailto:${email}`}
            variant={['label', 'blue', button?.variant && button.variant]}
          >
            {button?.label || `Email ${first_name}`}
          </Button>
        )}
      </div>
    </div>
  )
}

export default Staff
